module.exports = {
  Query: {
    fields: {
      consolePayments: {
        merge(existing, incoming) {
          return { ...existing, ...incoming };
        },
      },
      userManagement: {
        merge: true,
      },
      campaignWizard: {
        merge: true,
      },
    },
  },
  // CampaignOverviewDeliveryStatusCell: {
  //   // keyFields: false,
  //   fields: {
  //     moreInfo: {
  //       merge: true
  //     }
  //   },
  // },
  CampaignWizardNavigation: {
    keyFields: [],
  },
  SideBarCampaign: {
    keyFields: ['id', 'productId'],
  },
  CampaignOverviewStatusCell: {
    keyFields: ['campaignId'],
  },
  AdGroupOverviewStatusCell: {
    keyFields: ['adGroupId'],
  },
  AdOverviewStatusCell: {
    keyFields: ['adId'],
  },
  AdsPortalAdGroupTableResponse: {
    keyFields: ['lastSort'],
  },
  AdsPortalCampaignTableResponse: {
    keyFields: ['lastSort'],
  },
  AdsPortalAdTableResponse: {
    keyFields: ['lastSort'],
  },
  PerformanceOverviewCampaignSelectionResponse: {
    keyFields: [],
  },
  AdsPortalCampaignOverview: {
    keyFields: [],
  },
};
